<div class="fill-height p-2 d-flex justify-content-center">
  <div *ngIf="isLoading" class="d-flex h-100 align-items-center justify-content-center">
    <mat-spinner class="zx-small-icon-size"></mat-spinner>
  </div>
  <!-- helpers content -------------------------------------------------------------------------------------------------------- helpers content -->
  <div *ngIf="!isLoading" class="w-100 flex-grow-1 d-flex flex-column align-items-center justify-content-center gap-3">

    <h6 *ngIf="isHelpersOrSupportRoute()">
      {{ "helpers.thank-you-title" | translate }}
    </h6>

    <h6 *ngIf="currentRoute === 'remove'">
      {{ "helpers.remove-from-list-title" | translate }}
    </h6>

    <button class="rounded-pill text-white" mat-raised-button color="primary" type="button" 
      (click)="onButtonClick()" [disabled]="isRemoving">
      <span *ngIf="isHelpersOrSupportRoute() && !isRemoving">
        {{ "helpers.contact-support-whatsapp" | translate }}
      </span>
      <span *ngIf="currentRoute === 'remove' && !isRemoving">
        {{ "helpers.remove-me-from-list" | translate }}
      </span>
      <span *ngIf="isRemoving">
        {{ "helpers.removing" | translate }}
      </span>
    </button>

    <!-- thank you message -->
    <span class="zx-text-tiny zx-text-sm-small opacity-75 pt-2">
      {{ "helpers.thank-you-team" | translate }}
    </span>
    <!-- // thank you message -->

  </div>
</div>

<div class="p-2 d-flex flex-column">
  <div class="pt-2">
    <button class="w-100 rounded-pill fw-bold text-white" mat-raised-button
      type="button" color="primary" (click)="goToNewOrder()">
      {{ "main-nav.new-order" | translate }}
    </button>
  </div>
</div>

